function pad(number) {
    if (number < 10) {
        return `0${ number }`;
    }

    return number;
}

export default class Helper {
    constructor(root) {
        this.config = root.config;
    }

    getCurrentDay() {
        const now = new Date();

        return {
            date:   now.getDate(),
            month:  now.getMonth(),
            year:   now.getFullYear(),
            hour:   now.getHours(),
            minute: now.getMinutes()
        };
    }

    getDateStr(selectedDate) {
        const { dateMask } = this.config.getMasks();

        let { date, month, year } = selectedDate;

        date = (date != null) ? pad(date) : '';
        month = (month != null) ? pad(month + 1) : '';
        year = (year != null) ? year : '';

        return dateMask.mask
            .replace(/D+/, date)
            .replace(/M+/, month)
            .replace(/Y+/, year);
    }

    getTimeStr(payload) {
        const config = this.config.get();
        const { hour12 } = config.dateFormat;
        const { timeMask } = this.config.getMasks();

        let { hour, minute } = payload;

        if (hour == null || minute == null) {
            return '';
        }

        let ampm = '';

        if (hour12) {
            if (hour === 24) {
                hour = 0;
            }

            ampm = hour >= 12 ? 'PM' : 'AM';
            hour = (hour % 12) || 12;
        }

        hour = hour12 ? hour : pad(hour);
        minute = pad(minute);

        return timeMask.mask
            .replace(/h+/, hour)
            .replace(/m+/, minute)
            .replace(/t+/, ampm);
    }

    getDateAndTimeStr(parsed) {
        const { dateTimeMask } = this.config.getMasks();
        const date = this.getDateStr(parsed);
        const time = this.getTimeStr(parsed);

        if (!time) {
            return date;
        }

        return `${ date }${ dateTimeMask.divider }${ time }`;
    }

    getDateFromParsed({ date, month, year, hour, minute }) {
        try {
            return new Date(+year, +month, +date, +hour || 0, +minute || 0, 0, 0);
        }
        catch (err) {
            return null;
        }
    }

    checkDateIsValid({ date, month, year, hour, minute }) {
        const dateInstance = this.getDateFromParsed({ date, month, year, hour, minute });

        return (
            dateInstance &&
            dateInstance.getDate() === +date &&
            dateInstance.getMonth() === +month &&
            dateInstance.getFullYear() === +year &&
            hour == null || dateInstance.getHours() === +hour &&
            minute == null || dateInstance.getMinutes() === +minute
        );
    }


    getISOString(date) {
        const { type } = this.config.get();

        if (type === 'datetime') {
            return date.toISOString();
        }

        return `${ date.getFullYear() }-${ pad(date.getMonth() + 1) }-${ pad(date.getDate()) }`;
    }
}
